import { render, staticRenderFns } from "./modelView.vue?vue&type=template&id=c1a1b160&scoped=true"
import script from "./modelView.vue?vue&type=script&lang=js"
export * from "./modelView.vue?vue&type=script&lang=js"
import style0 from "./modelView.vue?vue&type=style&index=0&id=c1a1b160&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a1b160",
  null
  
)

export default component.exports